import LocalStorage from 'core/LocalStorage';
import Modal from 'modules/Modal';
import Popover from 'modules/components/Popover';

export default {
  components: {
    Popover,
  },
  data() {
    return {
      WANT_TEXT: '応募したい',
      WANTED_TEXT: 'メッセージ',
      isScouter: false, // 地域ユーザ
      isSignedIn: false,
      isClosed: false,
      isPopover: true,
      isLiked: false,
      showPopover: true,
      chatRoomId: null,
      modal: new Modal(),
      popoverHiddenKey: 'popover_wanted_scout_hidden',
      popoverStatusKey: 'popover_wanted_scout_status',
      popoverExpiredMonth: 1,
      popoverExpiredUnrealYear: 99, // 非現実的なPopOverの有効期限(地域ユーザに指定する)
      confirmModal: '#wanted-scout-confirm-modal',
    };
  },
  mounted() {
    this.isScouter = this.$el.getAttribute('data-is-scouter') === 'true';
    this.isSignedIn = this.$el.getAttribute('data-is-signed-in') === 'true';
    this.chatRoomId = this.$el.getAttribute('data-relation_chat_room_id');
    this.isLiked = this.$el.hasAttribute('data-is-liked');
    this.isClosed = this.$el.hasAttribute('data-is-closed');
    this.likeButtonSelector = this.$el.getAttribute('data-like-button-selector') || this.likeButtonSelector;
    this.confirmModal = this.$el.getAttribute('data-confirm-modal') || this.confirmModal;
    const key = LocalStorage.get(this.popoverHiddenKey);
    if (key) {
      this.showPopover = false;
    }
    const popoverStatus = LocalStorage.get(this.popoverStatusKey);
    if (popoverStatus === 'hide') {
      this.isPopover = false;
    }
  },
  computed: {
    isScouted() {
      return !!this.chatRoomId;
    },
    chatRoomUrl() {
      return `/chat_rooms/${this.chatRoomId}/chat_items`;
    },
    confirmModalId() {
      return this.confirmModal.slice(1);
    },
  },
  methods: {
    submit() {
      LocalStorage.set(this.popoverHiddenKey, '1');
      LocalStorage.set('chatroom_wanted_scout_popover', 'true');
      this.$refs.submit.click();
    },
    beforeSubmit($event) {
      if (!this.isSignedIn) {
        $event.preventDefault();
        window.EventBus.$emit('need-signup-prompt', '応募したい');
        return;
      }
      this.modal.open(this.confirmModal);
    },
    modalClose() {
      this.modal.close();
    },
    closePopover() {
      this.isPopover = false;
      const expired = new Date();
      if (this.isScouter) {
        // 地域ユーザは、一度のみPopOverを表示させるため、
        // 非現実的な数字として年に+99で指定する
        expired.setFullYear(expired.getFullYear() + this.popoverExpiredUnrealYear);
      } else {
        // 一般ユーザは、月に1回表示される
        expired.setMonth(expired.getMonth() + this.popoverExpiredMonth);
      }
      LocalStorage.set(this.popoverStatusKey, 'hide', expired);
    },
  },
};
